import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  const getUser = localStorage.getItem("userLogged");

  if (!getUser) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};
